import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../../select/eager-select/eager-select-reducer';
import { filterExtensionOption } from '../../../select/shared/filter-extension-option';
import { extensionLoadHuntGroupsActions } from '../extension-option.actions';

export const extensionHuntGroupsOptionFeatureKey = 'extensionHuntGroupOptions';

export type ExtensionHuntGroupsOptionState = EagerSelectState<ExtensionOption>;

const huntGroupAdapter = createEagerSelectAdapter<ExtensionHuntGroupsOptionState, ExtensionOption>({
   featureKey: extensionHuntGroupsOptionFeatureKey,
   selectId: (extension: ExtensionOption) => {
      return extension.extensionId;
   },
});

export const extensionHuntGroupsOptionSelectors = huntGroupAdapter.getSelectors(filterExtensionOption);

const initialHuntGroupState = huntGroupAdapter.getInitialState();

export const extensionHuntGroupOptionsReducer = createEagerSelectReducer(
   huntGroupAdapter,
   initialHuntGroupState,
   extensionLoadHuntGroupsActions.search,
   extensionLoadHuntGroupsActions.searchReset,
   extensionLoadHuntGroupsActions.loadFromApi,
   extensionLoadHuntGroupsActions.loadFromApiSuccess,
   extensionLoadHuntGroupsActions.loadFromApiFailure,
   null
);
